module.exports = __webpack_public_path__ + "static/media/icon-tag.f6249d90.svg";